import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "https://ljzjgvriwhplszofvjnm.supabase.co";
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxqempndnJpd2hwbHN6b2Z2am5tIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM5NDYzMjUsImV4cCI6MjA4OTUyMjMyNX0.JErOKiMWmuM1-RuPqdJf2uHpsxfjZemKuddiOKE8ne0";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
export const isSupabaseEnabled = true;
